import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface IConfirmation {
    events: Array<Object>,
    url: string
}

interface IConfirmationState {
    events: Array<Object>;
    receiptUrl: string;
}

const initialState: IConfirmationState = {
    events: [],
    receiptUrl: ""
};

export const confirmationSlice = createSlice({
    name: 'confirmation',
    initialState,
    reducers: {
        setConfirmationEvents: (state, {payload}: PayloadAction<IConfirmation>) => {
            let newState = {...state};
            newState.events = payload.events;

            return newState;
        },
        setReceiptUrl: (state, {payload}: PayloadAction<IConfirmation>) => {
            let newState = {...state};
            newState.receiptUrl = payload.url;
            return newState;
        }
    },
    extraReducers: (builder) => {
        builder.addDefaultCase((state, action) => {
            return state;
        })
    },
});
